export const getGifs = async (category) => {
	const URL= `https://api.giphy.com/v1/gifs/search?api_key=HXWAL4J7W5pfuav1GwSOs3tgGldTgfBD&q=${category}&limit=5`;
	const request = await fetch(URL);
	const {data} = await request.json();

	const gifs = data.map(img => ({
		id: img.id,
		title: img.title,
		url: img.images.downsized_medium.url
	}))
	
	return gifs;
}
